import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showConfig, setShowConfig] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("girobuit_cookies");
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("girobuit_cookies", "accepted");
    setVisible(false);
  };

  const handleConfig = () => {
    setShowConfig(true);
  };

  const handleSaveConfig = () => {
    localStorage.setItem("girobuit_cookies", "configured");
    setVisible(false);
    setShowConfig(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 w-full z-[100] bg-white border-t border-gray-200 px-4 md:px-8 py-4"
      style={{
        boxShadow: "0 -4px 20px rgba(0,0,0,0.08)",
        animation: "slideUp 0.4s ease-out",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      {!showConfig ? (
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-gray-600 leading-relaxed flex-1">
            <strong className="text-[#330000]">Usamos cookies</strong> para mejorar tu experiencia en nuestra web. Puedes aceptarlas todas o configurar tus preferencias.{" "}
            <a href="/cookies" className="text-[#ff0000] underline cursor-pointer">Más información sobre nuestra política de cookies</a>.
          </p>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={handleConfig}
              className="px-5 py-2.5 rounded-md border-2 border-[#330000] text-[#330000] text-sm font-600 whitespace-nowrap cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              style={{ fontWeight: 600 }}
            >
              Configurar
            </button>
            <button
              onClick={handleAccept}
              className="px-5 py-2.5 rounded-md bg-[#ff0000] text-white text-sm font-700 whitespace-nowrap cursor-pointer hover:bg-[#cc0000] transition-colors duration-200"
              style={{ fontWeight: 700 }}
            >
              Aceptar
            </button>
          </div>
        </div>
      ) : (
        <div className="max-w-7xl mx-auto">
          <h3 className="text-base font-700 text-[#330000] mb-3" style={{ fontWeight: 700 }}>Configurar cookies</h3>
          <div className="flex flex-col gap-2 mb-4">
            {[
              { label: "Cookies necesarias", desc: "Imprescindibles para el funcionamiento del sitio.", locked: true },
              { label: "Cookies analíticas", desc: "Nos ayudan a entender cómo usas la web.", locked: false },
              { label: "Cookies de marketing", desc: "Para mostrarte contenido relevante.", locked: false },
            ].map((item) => (
              <div key={item.label} className="flex items-center justify-between gap-4 py-2 border-b border-gray-100">
                <div>
                  <p className="text-sm font-600 text-[#330000]" style={{ fontWeight: 600 }}>{item.label}</p>
                  <p className="text-xs text-gray-500">{item.desc}</p>
                </div>
                <div className={`w-10 h-5 rounded-full flex items-center px-0.5 ${item.locked ? "bg-[#ff0000]" : "bg-gray-300"} cursor-pointer`}>
                  <div className={`w-4 h-4 rounded-full bg-white transition-transform duration-200 ${item.locked ? "translate-x-5" : "translate-x-0"}`}></div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleSaveConfig}
              className="px-5 py-2.5 rounded-md bg-[#ff0000] text-white text-sm font-700 whitespace-nowrap cursor-pointer hover:bg-[#cc0000] transition-colors duration-200"
              style={{ fontWeight: 700 }}
            >
              Guardar preferencias
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
